// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2V9xg","ranges":"BmiRanges_ranges__1qQ2R"};